import { fromJS } from 'immutable';

import {
  UPDATE_SELECTED_VARIANTS,
  UPDATE_VD_TOTAL_DISPLAY_OFFER_VALUES,
  UPDATE_VARIANT_SELECTOR_IN_VIEW,
  UPDATE_SELECTED_VD_OPTION_INDEX,
  UPDATE_SELECTED_VD_OPTION,
  UPDATE_VD_OFFER_THEME,
  UPDATE_VD_MR_OFFER_ID,
  UPDATE_VD_PRIMARY_PRODUCT,
} from './constants';

export const initialState = fromJS({
  mrOfferID: '',
  primaryProduct: {},
  theme: {},
  totalDisplayOfferValues: {
    totalPrice: 'XX.XX',
    offerPrice: 'XX.XX',
    discount: 'XX.XX',
    displayDiscount: false,
  },
  selectedVariants: [],
  isVDVariantSelectorInViewForAboveATC: false,
  selectedVDOptionIndex: -1,
  selectedVDOption: null,
});

function volumeDiscountPageReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_SELECTED_VARIANTS:
      return state.set(
        'selectedVariants',
        fromJS(action.updatedSelectedVariants),
      );
    case UPDATE_VD_TOTAL_DISPLAY_OFFER_VALUES:
      return state.set(
        'totalDisplayOfferValues',
        fromJS(action.updatedTotalDisplayOfferValues),
      );
    case UPDATE_VARIANT_SELECTOR_IN_VIEW:
      return state.set(
        'isVDVariantSelectorInViewForAboveATC',
        action.updatedIsVDVariantSelectorInViewForAboveATC,
      );
    case UPDATE_SELECTED_VD_OPTION_INDEX:
      return state.set(
        'selectedVDOptionIndex',
        fromJS(action.updatedSelectedVDOptionIndex),
      );
    case UPDATE_SELECTED_VD_OPTION:
      return state.set(
        'selectedVDOption',
        fromJS(action.updatedSelectedVDOption),
      );
    case UPDATE_VD_OFFER_THEME:
      return state.set('theme', fromJS(action.updatedTheme));
    case UPDATE_VD_MR_OFFER_ID:
      return state.set('mrOfferID', fromJS(action.updatedMrOfferID));
    case UPDATE_VD_PRIMARY_PRODUCT:
      return state.set('primaryProduct', fromJS(action.updatedPrimaryProduct));
    default:
      return state;
  }
}

export default volumeDiscountPageReducer;
